import { Allocation, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editAllocation(httpClient: HttpClient) {
  return (allocation: Identifiable<Allocation>, nextAllocation: Allocation) =>
    httpClient.sendHttpRequest<Identifiable<Allocation>>({
      endpoint: `/allocations/${allocation.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        allocatedHours: nextAllocation.allocatedHours,
        percentComplete: nextAllocation.percentComplete,
      },
    });
}

export { editAllocation };
